(function (app, ng) {
    simpleToastController.$inject = ["message", "$mdToast"];

    function simpleToastController(message, $mdToast) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                message: message,
                close: close
            });

        function close() {
            $mdToast.hide();
        }
    }

    undoToastController.$inject = ["message", "$mdToast", "$timeout"];

    function undoToastController(message, $mdToast, $timeout) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                undo: undo,
                message: message
            });

        function undo() {
            $mdToast.hide(true);
        }
    }

    yesNoToastController.$inject = ["message", "$mdToast"];

    function yesNoToastController(message, $mdToast) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                yes: yes,
                no: no,
                message: message
            });

        function yes() {
            $mdToast.hide(true);
        }

        function no() {
            $mdToast.hide(false);
        }
    }

    app.provider("figToaster", [function () {
        this.$get = ["$mdToast", function ($mdToast) {
            var service = {};

            service.showUndo = function (message, position, parent) {

                var options = {
                    templateUrl: "/App.Services/Toaster/undo-template.html",
                    position: position,
                    controller: undoToastController,
                    controllerAs: "$ctrl",
                    locals: {
                        message: message
                    },
                    bindToController: true,
                    autoWrap: false,
                    hideDelay: 2000
                };

                if (parent)
                    options.parent = parent;

                return $mdToast.show(options);
            };

            service.showYesNo = function (message, position, toastClass, parent) {

                var options = {
                    templateUrl: "/App.Services/Toaster/yesno-template.html",
                    position: position,
                    toastClass: toastClass,
                    controller: yesNoToastController,
                    controllerAs: "$ctrl",
                    locals: {
                        message: message
                    },
                    bindToController: true,
                    hideDelay: 0
                };

                if (parent)
                    options.parent = parent;

                return $mdToast.show(options);
            };

            //Cleaned up service to only call simple template toast and use toastClass param to define the toast's intention (e.g. is-success, .is-error)
            service.showSimple = function (message, position, toastClass, delay, parent) {
                var options = {
                    templateUrl: "/App.Services/Toaster/simple-template.html",
                    position: position,
                    toastClass: toastClass,
                    controller: simpleToastController,
                    controllerAs: "$ctrl",
                    locals: { message: message },
                    bindToController: true,
                    hideDelay: !!delay ? delay: 2000
                };

                if (parent)
                    options.parent = parent;

                return $mdToast.show(options);
            };

            return service;
        }];
    }]);

    app.directive("figToastContainer", ["figToastContainers", function (figToastContainers) {
        return {
            scope: {
                figToastContainer: "@"
            },
            restrict: "A",
            link: function (scope, elem) {
                elem[0].style.position = "relative";

                elem.on("$destroy", figToastContainers.register(scope.figToastContainer, elem));
            }
        };
    }]);

    app.provider("figToastContainers", [function () {
        this.$get = ["_", function (_) {
            var service = {};
            var containers = [];

            service.register = function (key, elem) {
                var obj = {
                    key: key,
                    elem: elem
                };

                containers.push(obj);

                return function () {
                    containers.splice(containers.indexOf(obj), 1);
                };
            };

            service.get = function (key) {
                return _.find(containers, { key: key }).elem;
            };

            return service;
        }];
    }]);
})(window.app, window.angular); // jshint ignore:line